import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  setStartDate,
  setEndDate,
  runQueryPagoda,
  runQuery,
  runQueryKJ,
} from "../../redux/action";
import { RootState } from "../../redux/reducer";
import { connect, ConnectedProps } from "react-redux";
import moment from "moment";
import _ from "lodash";
import { AllDataEvents } from "./event.config";
import DateFnsUtils from "@date-io/date-fns";
import { installationData } from "../../common/api";
import { AgGridReact } from "ag-grid-react";
import { Box, Button } from "@mui/material";
import "ag-grid-community/styles/ag-grid.css";
import 'react-tabs/style/react-tabs.css';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from "dayjs";



type PropsFromRedux = ConnectedProps<typeof connector>;
type ByStoreTabProps = PropsFromRedux & {};


const TestByStore: React.FC<ByStoreTabProps> = ({
  startDateObj,
  endDateObj,
  setStartDate,
  setEndDate,
  runQueryPagoda,
  runQuery,
  runQueryKJ,
}) => {
  
  const handleFromDateChange = (date: any | null) => {
    setStartDate(date.$d)
  };
  const handleToDateChange = (date: any | null) => {
    setEndDate(date.$d)
  };

  const [gridData, setGridData] = useState<any[] | undefined>([]);
  const [colDefs] = useState([
    { field: "player_id" ,filter: true},
    { field: "store_id" ,filter: true },
    { field: "banner_name" },
    {field:"experience"},
    { field: "device" },
    { field: "store_location" },
    { field: "store_type" },
    { field: "procurement_status"},
    { field: "operation_status"},
    { field: "city" },
    { field: "state" },
    { field: "installation_date" },
    { field: "device_placement_Easels" },
    { field: "device_position_Easels" },
    { field: "user_session_by_store" },
    { field: "total_virtual_try_on_session" },
    { field: "total_pictures_taken" },
    { field: "total_product_views" },
    { field: "media_tap" },
    { field: "total_social_media_requests" },
    { field: "total_social_media_image_views" },
    { field: "total_social_media_item_views" },
    { field: "tutorials_opened" },
    { field: "aos_toggled" },
    { field: "avg" },
  ]);
  
  const gridRef = useRef<any>(null);
  const getInitialData = async () => {
    await getSelectedAPIList();
  };
  const onBtnExport = useCallback(() => {
    gridRef.current.api.exportDataAsCsv({fileName:"All_KPI"});
  }, []);
  const getSelectedAPIList = async () => {
    // Fetch installation data
    let installationdata: any[] = [];
    installationData().then((res) => (installationdata = res?.data));

    const startDate = moment(startDateObj).format("YYYYMMDD");
    const endDate = moment(endDateObj).format("YYYYMMDD");
    let query = `SELECT event_name,param2.value.string_value as player_id,param1.value.string_value AS store_id, param.value.string_value AS storeName,'pagoda' as project ,'catalog' as catagory, count(1) as value
    FROM \`pagoda-cms-prod.analytics_211897923.events_*\`,
    UNNEST(event_params) AS param ,UNNEST(event_params) AS param1,UNNEST(event_params) AS param2 WHERE (param.key = 'vv_store_name') AND ( param1.key = 'vv_store_id') and (param2.key ="vv_player_id" or param2.key = 'PLAYER_ID')
    AND event_date >= '${startDate}' AND  event_date <= '${endDate}'
    group by 1,2,3,4`;

    const pagodaResult: any = await runQueryPagoda({ query });

    query = `SELECT event_name,param2.value.string_value as player_id,param1.value.string_value AS store_id, param.value.string_value AS storeName,'zales' as project ,'catalog' as catagory, count(1) as value
        FROM \`zales-cms-prod.analytics_205854940.events_*\`,UNNEST(event_params) AS param ,UNNEST(event_params) AS param1,UNNEST(event_params) AS param2  WHERE param.key = 'vv_store_name' and stream_id = '2757255477' AND  param1.key = 'vv_store_id' AND (param2.key ="vv_player_id" or param2.key = 'PLAYER_ID') AND event_date >= '${startDate}' AND  event_date <= '${endDate}' group by 1,2,3,4`;

    const zalesResult: any = await runQuery({ query });

    query = `SELECT event_name,param2.value.string_value as player_id,param1.value.string_value AS store_id, param.value.string_value AS storeName,'zales' as project,'signage' as catagory, count(1) as value
    FROM \`zales-cms-prod.analytics_205854940.events_*\`,
    UNNEST(event_params) AS param ,UNNEST(event_params) AS param1,UNNEST(event_params) AS param2 WHERE (param.key = 'STORE_NAME' or param.key = 'vv_store_name' ) AND ( param1.key = 'STORE_ID' or param1.key = 'vv_store_id') AND (param2.key ="vv_player_id" or param2.key = 'PLAYER_ID') and stream_id ='1503186663'
    AND event_date >= '${startDate}' AND  event_date <= '${endDate}' group by 1,2,3,4`;

    const zalesSignageResult: any = await runQuery({ query });

    query = `SELECT event_name,param2.value.string_value as player_id,param1.value.string_value AS store_id, param.value.string_value AS storeName,'kay' as project ,'catalog' as catagory, count(1) as value
    FROM \`kay-cms-prod.analytics_268258331.events_*\`,
    UNNEST(event_params) AS param ,UNNEST(event_params) AS param1,UNNEST(event_params) AS param2 WHERE (param.key = 'vv_store_name') and stream_id ='2614929667' and param.value.string_value not in ('Kay - VV Test Lab') AND ( param1.key = 'vv_store_id') AND (param2.key ="vv_player_id" or param2.key = 'PLAYER_ID')
    AND event_date >= '${startDate}' AND  event_date <= '${endDate}'
    group by 1,2,3,4`;

    const kayResult: any = await runQueryKJ({ query });

    // Added param.key=vv_store_name in below query

    query = `SELECT event_name,param2.value.string_value as player_id,param1.value.string_value AS store_id, param.value.string_value AS storeName,'kay' as project ,'signage' as catagory, count(1) as value
    FROM \`kay-cms-prod.analytics_268258331.events_*\`,
    UNNEST(event_params) AS param ,UNNEST(event_params) AS param1,UNNEST(event_params) AS param2 WHERE (param.key = 'STORE_NAME' or param.key = 'vv_store_name' ) AND (param1.key = 'vv_store_id' or param1.key='STORE_ID') AND (param2.key ="vv_player_id" or param2.key = 'PLAYER_ID')
    and stream_id ='2414542131' AND event_date >= '${startDate}' AND  event_date <= '${endDate}' group by 1,2,3,4 order by value desc `;

    const kaySignageResult: any = await runQueryKJ({ query });

    // avg session time--------------
    query = `SELECT param4.value.string_value as player_id, param2.value.string_value AS store_id, param.value.string_value AS storeName,'pagoda' as project ,'catalog' as catagory,
    count(1) as session_count,ROUND(SAFE_DIVIDE(SUM(CAST(param1.value.string_value AS FLOAT64)), count('vv_store_id')),2) as avg
 FROM \`pagoda-cms-prod.analytics_211897923.events_*\`,
 UNNEST(event_params) AS param ,UNNEST(event_params) AS param1 ,UNNEST(event_params) as param2,UNNEST(event_params) as param4
  WHERE (param.key = 'vv_store_name') AND (param1.key = 'vv_session_duration_time_in_secs_string') AND (param2.key='vv_store_id') AND (param4.key ="vv_player_id" or param4.key = 'PLAYER_ID') 
  AND event_name = "vv_user_session_end_banter" AND event_date >= '${startDate}' AND  event_date <= '${endDate}'
 group by 1,2,3`;

    const pagodaAvgResult: any = await runQueryPagoda({ query });

    query = `SELECT param4.value.string_value as player_id,param2.value.string_value AS store_id, param.value.string_value AS storeName,'zales' as project ,'catalog' as catagory,
    count(1) as session_count,ROUND(SAFE_DIVIDE(SUM(CAST(param1.value.string_value AS FLOAT64)), count('vv_store_id')),2) as avg
 FROM \`zales-cms-prod.analytics_205854940.events_*\`,
 UNNEST(event_params) AS param ,UNNEST(event_params) AS param1 ,UNNEST(event_params) as param2,UNNEST(event_params) as param4
  WHERE (param.key = 'vv_store_name') AND (param1.key = 'vv_session_duration_time_in_secs_string') AND (param2.key='vv_store_id') AND (param4.key ="vv_player_id" or param4.key = 'PLAYER_ID')
  AND event_name = "vv_user_session_end" AND event_date >= '${startDate}' AND  event_date <= '${endDate}' 
  and stream_id = '2757255477' group by 1,2,3`;

    const zalesAvgResult: any = await runQuery({ query });

    query = `SELECT param4.value.string_value as player_id,param2.value.string_value AS store_id,param.value.string_value AS storeName,'zales' as project,'signage' as catagory,count(1) as session_count,ROUND(SAFE_DIVIDE(SUM(CAST(param1.value.string_value AS FLOAT64)), count('vv_store_id')),2) as avg
    FROM \`zales-cms-prod.analytics_205854940.events_*\`,
    UNNEST(event_params) AS param ,UNNEST(event_params) AS param1,UNNEST(event_params) as param2,UNNEST(event_params) as param4 WHERE (param.key = 'STORE_NAME' or param.key = 'vv_store_name' ) AND (param1.key = 'vv_session_duration_time_in_secs_string')  AND (param2.key='vv_store_id' or param2.key='STORE_ID' )
     and stream_id = '1503186663' AND event_name = "vv_session_end" AND (param4.key ="vv_player_id" or param4.key = 'PLAYER_ID')
    AND event_date >= '${startDate}' AND  event_date <= '${endDate}'
    group by 1,2,3`;

    const zalesSignageAvgResult: any = await runQuery({ query });

    query = `SELECT param4.value.string_value as player_id,param2.value.string_value AS store_id, param.value.string_value AS storeName,'kay' as project ,'catalog' as catagory,
    count(1) as session_count,ROUND(SAFE_DIVIDE(SUM(CAST(param1.value.string_value AS FLOAT64)), count('vv_store_id')),2) as avg
FROM \`kay-cms-prod.analytics_268258331.events_*\`,
UNNEST(event_params) AS param ,UNNEST(event_params) AS param1 ,UNNEST(event_params) as param2,UNNEST(event_params) as param4
WHERE (param.key = 'vv_store_name') AND (param1.key = 'vv_session_duration_time_in_secs_string') AND (param2.key='vv_store_id') and (param4.key ="vv_player_id" or param4.key = 'PLAYER_ID')
AND event_name = "vv_user_session_end" AND event_date >= '${startDate}' AND  event_date <= '${endDate}'
AND stream_id ='2614929667' group by 1,2,3`;

    const kayAvgResult: any = await runQueryKJ({ query });

    query = `SELECT param4.value.string_value as player_id,param2.value.string_value AS store_id, param.value.string_value AS storeName,'kay' as project ,'signage' as catagory,
    count(1) as session_count,ROUND(SAFE_DIVIDE(SUM(CAST(param1.value.string_value AS FLOAT64)), count('vv_store_id')),2) as avg
FROM \`kay-cms-prod.analytics_268258331.events_*\`,
UNNEST(event_params) AS param ,UNNEST(event_params) AS param1 ,UNNEST(event_params) as param2,UNNEST(event_params) as param4
WHERE (param.key = 'STORE_NAME' or param.key = 'vv_store_name' ) AND (param1.key = 'vv_session_duration_time_in_secs_string') AND (param2.key='vv_store_id' or param2.key='STORE_ID' )
AND event_name = "vv_session_end" and (param4.key ="vv_player_id" or param4.key = 'PLAYER_ID')  AND event_date >= '${startDate}' AND  event_date <= '${endDate}'
AND stream_id ='2414542131' group by 1,2,3`;
    const kaySinageAvgResult: any = await runQueryKJ({ query });

    let mergePagoda = _.map(pagodaResult, function (item) {
      return _.extend(
        item,
        _.find(pagodaAvgResult, { player_id: item.player_id })
      );
    });
    let mergeZales = _.map(zalesResult, function (item) {
      return _.extend(
        item,
        _.find(zalesAvgResult, { player_id: item.player_id })
      );
    });
    let mergeZalesSignage = _.map(zalesSignageResult, function (item) {
      return _.extend(
        item,
        _.find(zalesSignageAvgResult, { player_id: item.player_id })
      );
    });
    let mergeKay = _.map(kayResult, function (item) {
      return _.extend(
        item,
        _.find(kayAvgResult, { player_id: item.player_id })
      );
    });
    let mergeKaySignage = _.map(kaySignageResult, function (item) {
      return _.extend(
        item,
        _.find(kaySinageAvgResult, { player_id: item.player_id })
      );
    });

    let allResultsCombined = [
      ...mergePagoda,
      ...mergeZales,
      ...mergeKay,
      ...mergeZalesSignage,
      ...mergeKaySignage,
    ];

    let filterEvents: any[] = [];
    allResultsCombined.forEach((item) => {
      item.user_session_by_store = 0;
      item.total_virtual_try_on_session = 0;
      item.total_pictures_taken = 0;
      item.total_product_views = 0;
      item.media_tap = 0;
      item.total_social_media_requests = 0;
      item.total_social_media_image_views = 0;
      item.total_social_media_item_views = 0;
      item.aos_toggled = 0;
      item.tutorials_opened = 0;
      AllDataEvents.forEach((element: any) => {
        if (
          element.label === "User Sessions by Store" &&
          element.events.includes(item.event_name)
        ) {
          if(item.catagory === 'catalog' && item.event_name ==="vv_user_session_start" || item.catagory === 'catalog' && item.event_name ==="vv_user_session_start_banter"  ){
            if (filterEvents.some((val) => val.player_id == item.player_id)) {
              let index = filterEvents.findIndex(
                (object) => object.player_id == item.player_id
              );
              if (index !== -1) {
                filterEvents[index].user_session_by_store += parseInt(item.value);
              }
            } else {
              item.user_session_by_store = parseInt(item.value);
              filterEvents.push(item);
            }
          }
          if(item.catagory === 'signage' && item.event_name === "vv_session_start" ){
            if (filterEvents.some((val) => val.player_id == item.player_id)) {
              let index = filterEvents.findIndex(
                (object) => object.player_id == item.player_id
              );
              if (index !== -1) {
                filterEvents[index].user_session_by_store += parseInt(item.value);
              }
            } else {
              item.user_session_by_store = parseInt(item.value);
              filterEvents.push(item);
            }
          }
         
        }
        if (
          element.label === "Total Virtual Try-On Sessions" &&
          element.events.includes(item.event_name)
        ) {
          if (filterEvents.some((val) => val.player_id == item.player_id)) {
            let index = filterEvents.findIndex(
              (object) => object.player_id == item.player_id
            );
            if (index !== -1) {
              filterEvents[index].total_virtual_try_on_session += parseInt(
                item.value
              );
            }
          } else {
            item.total_virtual_try_on_session = parseInt(item.value);
            filterEvents.push(item);
          }
        }
        if (
          element.label === "Total Pictures Taken" &&
          element.events.includes(item.event_name)
        ) {
          if (filterEvents.some((val) => val.player_id == item.player_id)) {
            let index = filterEvents.findIndex(
              (object) => object.player_id == item.player_id
            );
            if (index !== -1) {
              filterEvents[index].total_pictures_taken += parseInt(item.value);
            }
          } else {
            item.total_pictures_taken = parseInt(item.value);
            filterEvents.push(item);
          }
        }
        if (
          element.label === "Total Product Views" &&
          element.events.includes(item.event_name)
        ) {
          if (filterEvents.some((val) => val.player_id == item.player_id)) {
            let index = filterEvents.findIndex(
              (object) => object.player_id == item.player_id
            );
            if (index !== -1) {
              filterEvents[index].total_product_views += parseInt(item.value);
            }
          } else {
            item.total_product_views = parseInt(item.value);
            filterEvents.push(item);
          }
        }
        if (
          element.label === "Media Tap" &&
          element.events.includes(item.event_name)
        ) {
          if (filterEvents.some((val) => val.player_id == item.player_id)) {
            let index = filterEvents.findIndex(
              (object) => object.player_id == item.player_id
            );
            if (index !== -1) {
              filterEvents[index].media_tap += parseInt(item.value);
            }
          } else {
            item.media_tap = parseInt(item.value);
            filterEvents.push(item);
          }
        }
        if (
          element.label === "Total Social Media Requests" &&
          element.events.includes(item.event_name)
        ) {
          if (filterEvents.some((val) => val.player_id == item.player_id)) {
            let index = filterEvents.findIndex(
              (object) => object.player_id == item.player_id
            );
            if (index !== -1) {
              filterEvents[index].total_social_media_requests += parseInt(
                item.value
              );
            }
          } else {
            item.total_social_media_requests = parseInt(item.value);
            filterEvents.push(item);
          }
        }
        if (
          element.label === "Total Social Media Image Views" &&
          element.events.includes(item.event_name)
        ) {
          if (filterEvents.some((val) => val.player_id == item.player_id)) {
            let index = filterEvents.findIndex(
              (object) => object.player_id == item.player_id
            );
            if (index !== -1) {
              filterEvents[index].total_social_media_image_views += parseInt(
                item.value
              );
            }
          } else {
            item.total_social_media_image_views = parseInt(item.value);
            filterEvents.push(item);
          }
        }
        if (
          element.label === "Total Social Media Item Views" &&
          element.events.includes(item.event_name)
        ) {
          if (filterEvents.some((val) => val.player_id == item.player_id)) {
            let index = filterEvents.findIndex(
              (object) => object.player_id == item.player_id
            );
            if (index !== -1) {
              filterEvents[index].total_social_media_item_views += parseInt(
                item.value
              );
            }
          } else {
            item.total_social_media_item_views = parseInt(item.value);
            filterEvents.push(item);
          }
        }
        if (
          element.label === "AOS Toggled" &&
          element.events.includes(item.event_name)
        ) {
          if (filterEvents.some((val) => val.player_id == item.player_id)) {
            let index = filterEvents.findIndex(
              (object) => object.player_id == item.player_id
            );
            if (index !== -1) {
              filterEvents[index].aos_toggled += parseInt(item.value);
            }
          } else {
            item.aos_toggled = parseInt(item.value);
            filterEvents.push(item);
          }
        }
        if (
          element.label === "Tutorials Opened" &&
          element.events.includes(item.event_name)
        ) {
          if (filterEvents.some((val) => val.player_id == item.player_id)) {
            let index = filterEvents.findIndex(
              (object) => object.player_id == item.player_id
            );
            if (index !== -1) {
              filterEvents[index].tutorials_opened += parseInt(item.value);
            }
          } else {
            item.tutorials_opened = parseInt(item.value);
            filterEvents.push(item);
          }
        }
      });
    });
    if (installationdata.length > 0) {
      let newData = _.map(installationdata, function (item) {
        return _.extend(
          item,
          _.find(filterEvents, { player_id: item.player_id.toString() })
        );
      });
      newData.sort(function (left, right) {
        return moment
          .utc(left.installation_date)
          .diff(moment.utc(right.installation_date));
      });
      setGridData(newData);
    }
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: 30,
          marginBottom: 50,
        }}
      >
        <div
          style={{
            display: "flex",
            flex: 1,
            padding: 16,
            alignItems: "center",
            marginBottom: 20,
          }}
        >


<LocalizationProvider dateAdapter={AdapterDayjs}>
<DatePicker

label="From Date"
format="MM/DD/YYYY"
value={dayjs(startDateObj)}
sx={{marginRight:'10px',}}
onChange={handleFromDateChange}
/>
<DatePicker
label="To Date"
format="MM/DD/YYYY"
value={dayjs(endDateObj)}
sx={{marginRight:'10px'}}
onChange={handleToDateChange}
/>
    </LocalizationProvider>
          {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              margin="normal"
              id="date-picker-dialog"
              label="From Date"
              format="MM/dd/yyyy"
              value={startDateObj}
              onChange={handleFromDateChange}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              autoOk={true}
            />

            <KeyboardDatePicker
              style={{ marginLeft: 16 }}
              margin="normal"
              id="date-picker-dialog"
              label="To Date"
              format="MM/dd/yyyy"
              value={endDateObj}
              onChange={handleToDateChange}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              autoOk={true}
            />
          </MuiPickersUtilsProvider> */}


          <Button
            variant="contained"
            color="secondary"
            sx={{
              width: 150,
              height:40,
              marginLeft: 5,
            }}
            onClick={() => getInitialData()}
          >
            Apply
          </Button>
        </div>
      </div>
      <Box sx={{ margin: "10px 0px",display:"flex",justifyContent:"end" }}>
        <Button variant="contained" color="primary" onClick={onBtnExport}>
          Downlaod CSV
        </Button>
      </Box>
      <div
        className="ag-theme-alpine"
        style={{ height: "50vh", width: "100%", margin: "auto"}}
      >
        <AgGridReact
          rowData={gridData}
          columnDefs={colDefs}
          animateRows={true}
          ref={gridRef}
        ></AgGridReact>
      </div>
    </div>
  );
};

const mapState = (state: RootState) => ({
  isUserLoggedIn: state.user.isUserLoggedIn,
  startDateObj: state.report.startDate,
  endDateObj: state.report.endDate,
  dateRange: state.report.dateRange,
});

const connector = connect(mapState, {
  setStartDate,
  setEndDate,
  runQueryPagoda,
  runQuery,
  runQueryKJ,
});

export default connector(TestByStore);
